import { useMemo } from 'react';
import { useCampaignsApi } from '../../campaigns/api/CampaignsApi';

export function useSurveysApi() {
  const campaignsApi = useCampaignsApi();

  return useMemo(
    () => ({
      searchSurveys: campaignsApi.searchSurveys,
    }),
    [campaignsApi],
  );
}